import axios from "axios";
import { CUSTOMER_API_URL } from "../constants";
import { Setting } from "../App";
import { SubscriptionsApiType, CancelSurveyEnable } from "../types/api/subscriptions-api-type";

export const useCancelSurvey = (setting: Setting) => {
  const cancelSurvey = (
    success: (info: CancelSurveyEnable) => void,
    failed?: (message: string) => void
  ) => {
    (async () => {
      try {
        const response = await axios.post(
          `${CUSTOMER_API_URL}?action=getSubscriptions`,
          {},
          { headers: { Authorization: setting.token } }
        );

        const subscriptions = (response.data as SubscriptionsApiType).filter(
          (subscription) => subscription.status === "ACTIVE" || subscription.status === "PAUSED"
        );
        if (subscriptions.length === 0) return;

        const subscription = subscriptions[0];


        const cancelSurveyResponse = await axios.post(
          `${CUSTOMER_API_URL}?action=getCancelSurvey`,
          {},
          {
            headers: { Authorization: setting.token },
          }
        );

        success(cancelSurveyResponse.data as CancelSurveyEnable);

      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  return {
    cancelSurvey,
  };
};
